var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { useLang } from '../hooks/use-lang';
import { Toggle } from '../elements/toggle';
import { classNames } from '@shapeable/utils';
var cls = classNames('entity-follow-toggle');
export var EntityFollowToggleDefaultProps = {
  isUnfollow: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    text-transform: uppercase;\n    font-size: ", ";\n  "], ["\n    text-transform: uppercase;\n    font-size: ", ";\n  "])), theme.FONT_SIZE(13))
});
// -------- Components -------->
var My = {
  Container: styled(Toggle)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var EntityFollowToggle = function (props) {
  var className = props.className,
    isUnfollow = props.isUnfollow;
  var t = useLang();
  var onClick = function () {
    if (props.onClick) {
      props.onClick();
    }
  };
  return React.createElement(My.Container, {
    onClick: onClick,
    className: className,
    isOn: isUnfollow,
    isHalfOn: false,
    onLabel: isUnfollow && t('Following'),
    offLabel: !isUnfollow && t('Follow')
  });
};
EntityFollowToggle.defaultProps = EntityFollowToggleDefaultProps;
EntityFollowToggle.cls = cls;
var templateObject_1, templateObject_2;